// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__12Bl-","label":"CategoryService_label__1tpKH","location":"CategoryService_location__QWsVV"};